import React from 'react';
import Hero from '../components/home/Hero';
import ProjectsGrid from '../components/home/ProjectsGrid';
import FeatureBox from '../components/home/FeatureBox';
import PageMeta from '../components/PageMeta';
import { businessInfo } from '../utils/generalData';

const HomePage = () => {
    return (
        <>
            <PageMeta
                description="Software developer building audio plugins and games. Creator of RSO, an expressive VST3 synthesizer. Based in Lyon, France."
                canonicalPath="/"
            />
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": businessInfo.name,
                "url": "https://lperron.com",
                "logo": "https://lperron.com/icon-512.png",
                "description": "Software developer building audio plugins and games. Creator of RSO synthesizer and various creative tools.",
                "founder": {
                    "@type": "Person",
                    "name": businessInfo.name
                },
                "contactPoint": {
                    "@type": "ContactPoint",
                    "email": "me@lperron.com"
                },
                "address": {
                    "@type": "PostalAddress",
                    "addressLocality": businessInfo.address.city,
                    "addressCountry": businessInfo.address.country.en
                },
                "sameAs": [
                    "https://gitlab.com/lperron/"
                ],
                "knowsAbout": [
                    "Audio Software Development",
                    "VST Plugin Development", 
                    "Game Development",
                    "Digital Signal Processing",
                    "Music Technology"
                ]
            })}} />
            <Hero />
            <ProjectsGrid />
            <FeatureBox />
        </>
    );
};

export default HomePage;